<portal-card class="card--table">
  <ng-container header>{{ 'translations.title' | portalTranslate }}</ng-container>

  <ng-container actions>
    <portal-icon-button
      [loading]="downloading"
      (onClick)="downloadTranslations()"
      iconClass="far fa-file-archive"
    >
      <span class="ms-1">{{ 'translations.download' | portalTranslate }}</span>
    </portal-icon-button>
  </ng-container>

  <portal-loading-indicator-container [loading]="loading">
    <div class="simple-table">
      <portal-filter-input
        #filter="filter"
        [calculateMetaData]="calculateMetaData"
        [entries]="data()"
        [properties]="metaDataProperties"
        (changed)="filter.filterChanged.emit($event)"
        portalDataTableFilter
      ></portal-filter-input>

      <table class="table table-hover" portalTable>
        <thead>
          <tr>
            <th>{{ 'dev.translator.overview.table.header.key' | translate }}</th>
            @for (language of languageKeys; track language) {
              <th>{{ language }}</th>
            }
            <th class="simple-table__actions"></th>
          </tr>
        </thead>
      </table>
    </div>
  </portal-loading-indicator-container>
</portal-card>

<ng-container *portalTableCell="let entry; data: 'key'">
  <button class="btn btn-link btn--portal-link" (click)="openTranslateEditor(entry.key)">
    {{ entry.key }}
  </button>
</ng-container>

<ng-container *portalTableCell="let entry; id: 'actions'; class: 'simple-table__actions'; sortable: false">
  <!-- Edit translation -->
  <portal-icon-button
    [portalTippy]="'generic.edit.entry' | translate"
    (onClick)="openTranslateEditor(entry.key)"
    iconClass="far fa-pencil"
  ></portal-icon-button>
</ng-container>
